export class ScrollTo extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  static get requiredAttributes () {
    return ['data-target']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onClick.bind(this))
  }

  onClick () {
    if (!this.target) return

    this.target.scrollIntoView({ behavior: 'smooth' })
  }

  get target () {
    return window.BAO.Utils.getElement(this.dataset.target)
  }
}

if (!customElements.get('scroll-to')) {
  customElements.define('scroll-to', ScrollTo, { extends: 'button' })
}
